import React from "react";
import Slider, { SliderThumb } from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import RazProgressSVG from "../../../components/UI/SVG_IMGs/RazProgressSVG";

// Custom thumb with your SVG
function RazThumbComponent(props) {
    return (
        <SliderThumb {...props}>
            <RazProgressSVG />
        </SliderThumb>
    );
}

// Styled Airbnb slider
const AirbnbSlider = styled(Slider)(({ theme }) => ({
    color: "#ED6628",
    height: 3,
    padding: "13px 0",
    boxShadow: "none",
    "& .MuiSlider-thumb": {
        height: 55,
        width: 68,
        zIndex: 3,
        top: 6,
        backgroundColor: "transparent !important",
        border: "none !important",
        outline: "none !important",
        boxShadow: "none !important",
        "&::before, &::after": {
            display: "none !important",
        },
        "&:hover, &.Mui-focusVisible, &.Mui-active": {
            backgroundColor: "transparent !important",
            border: "none !important",
            outline: "none !important",
            boxShadow: "none !important",
        },
        "& svg": {
            width: "100%",
            height: "100%",
            boxShadow: "none",
        },
        [theme.breakpoints.down("sm")]: {
            top: 14,
        },
    },
    "& .MuiSlider-track": {
        color: "#ED6628",
        height: '10px',
        zIndex: 1,
    },
    "& .MuiSlider-rail": {
        color: "#d8d8d8",
        opacity: 1,
        height: '10px',
        zIndex: 1,
    },
}));

export { AirbnbSlider, RazThumbComponent };
